export default __webpack_public_path__ + "static/media/王釧茹.91a985f0.png";